import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const HomeMottoFrame: React.FC<IProps> = (props) => {
	return (
		<svg
			width="375"
			height="992"
			viewBox="0 0 375 992"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M-38.348 0C-233.757 0 -325.807 145.774 -325.807 145.774L-326 992C-326 992 -179.478 924.774 -38.541 924.774C102.396 924.774 133.606 992 344.847 992C522.907 992 621 888.602 621 888.602V0C621 0 490.595 80.6816 345.04 80.6816C199.485 80.6816 157.061 0 -38.348 0Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(HomeMottoFrame);
